import type {
  CreateMachineProductRequest,
  MachineProductEntity,
} from "../types/machine-product";
import type { MachineProductRepository } from "../repositories/machine-product-repository";
import { AppError } from "../../shared/utils/error-handler";

export class MachineProductUseCase {
  constructor(private machineProductRepository: MachineProductRepository) {}

  async createMachineProduct(
    request: CreateMachineProductRequest,
  ): Promise<MachineProductEntity> {
    try {
      return await this.machineProductRepository.createMachineProduct(request);
    } catch (error) {
      throw new AppError(
        String(error) || "machine product를 생성하지 못했습니다.",
        "MACHINE_PRODUCT_CREATE_FAILED",
        error,
      );
    }
  }

  async searchMachineProduct(machineId: number): Promise<MachineProductEntity[]> {
    try {
      return await this.machineProductRepository.searchMachineProduct(machineId);
    } catch (error) {
      throw new AppError(
        String(error) || "machine product를 검색하지 못했습니다.",
        "MACHINE_PRODUCT_SEARCH_FAILED",
        error,
      );
    }
  }
}